import PropTypes from 'prop-types';
import React from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Toast.css';

var Toast = function Toast(_ref) {
  var autoClose = _ref.autoClose,
      closeButton = _ref.closeButton,
      hideProgressBar = _ref.hideProgressBar,
      draggable = _ref.draggable;
  return React.createElement(ToastContainer, {
    autoClose: autoClose,
    closeButton: closeButton,
    hideProgressBar: hideProgressBar,
    draggable: draggable,
    transition: Slide
  });
};

Toast.propTypes = {
  autoClose: PropTypes.number,
  closeButton: PropTypes.bool,
  hideProgressBar: PropTypes.bool,
  draggable: PropTypes.bool
};
Toast.defaultProps = {
  autoClose: 5000,
  closeButton: false,
  hideProgressBar: true,
  draggable: false
};
export default Toast;